export default {"src":"/_next/static/media/business-trip.8d9928a1.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};